export const FILENAME_FILTER_INDEX = 0;
export const TYPES_FILTER_INDEX = 1;
